import { Component, Input, OnInit, SimpleChanges,OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbActiveModal,NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CreatejobComponent } from '../createjob/createjob.component';
import { JobpropertiesComponent } from '../jobproperties/jobproperties.component';
import { CommonService } from '../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { W700servicesService } from '../services/w700services.service';
import { NewauditComponent } from '../newaudit/newaudit.component';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TabChangeService } from '../services/tab-change.service';
import { ModalTabVisibilityService } from '../services/modal-tab-visibility.service';

@Component({
  selector: 'app-w700jobslist',
  templateUrl: './w700jobslist.component.html',
  styleUrls: ['./w700jobslist.component.scss']
})

export class W700jobslistComponent implements OnInit, OnDestroy {
  private savePropertiesEventSubscription: Subscription;

  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'w700-jobs';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];

  screenHeight: number;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private service: CommonService,
    private w700service: W700servicesService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private activeModal: NgbActiveModal,
    private tabChangeService: TabChangeService,
    private modalTabVisibility: ModalTabVisibilityService
  ) { }
  classw700: string = '';
  deploymentkey: string = '';
  searchText: string = '';
  usernamedisplay: string;
  userrole: string = '';
  jobNames: string[] = []; 
  isDeployement: string = "";
  pagerolepermisions: any = '';
  keywordsearch_deployment ="name";

  deployemntlist: any = [];
  private static readonly displayFrequency: { [key: string]: string } = {
    'Seconds': 'S',
    'Minutes': 'M',
    'Hours': 'H',
    'Daily': 'D'
  };

  ngOnInit() {
    this.screenHeight = window.innerHeight - 229;
    this.getdeploymentconfiguration();
    this.savePropertiesEventSubscription = this.w700service.savePropertiesEvent.subscribe(
      (data: string) => {
        this.onKeyUpSearchJobslist(data);
        window.location.reload();

      }
    );
    
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.modalTabVisibility.hideForeignOwnedModals('data-w700jobslist-modal');
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
    // this.classw700 = 'mat-list-item ng-star-inserted active';
    // if (await this.service.checksession() == true) {
    //   var rolepermissinslist = JSON.parse(sessionStorage.getItem('rolepermissions'));
    //   this.pagerolepermisions = rolepermissinslist.filter(c => c.module == 'w700')[0];
    // }

    // if (this.router.url.includes("w700jobslist")) {
    //   this.classw700 = 'mat-list-item ng-star-inserted active';
    // }
    // else {
    //   this.classw700 = '';
    // }

    // if (await this.service.checksession() == true) {
    //   this.usernamedisplay = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['FormattedDisplayName'];
    //   this.userrole = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['role'];
    //   var rolepermissinslist = JSON.parse(sessionStorage.getItem('rolepermissions'));
    //   this.pagerolepermisions = rolepermissinslist.filter(c => c.module == 'w700')[0];
    //   if (this.pagerolepermisions != undefined) {
    //     this.route.queryParams.subscribe(
    //       params => {
    //         this.deploymentkey = params['deploymentkey'];
    //       }
    //     )
    //   }
    // }
  }

  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    if (this.savePropertiesEventSubscription) {
      this.savePropertiesEventSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
  }

  getdeploymentconfiguration() {
    this.service.getDeployments("Deployments").subscribe(
      data => {
        if (data.length > 0) {
          this.deployemntlist= data;
        } else if (data.length === 0) {
          this.deployemntlist = [];
        }
    },error=>{
      this.ngxUiLoaderService.stop()
    })
  }

 
  isLoadingResult: boolean = false;
  ChangeDeployment(event) {
 
    if ( event !== "") {
      this.isDeployement = event.name
      //this.onKeyUpSearchJobslist(this.searchtext)
    }
  }

  searchDeplyoementCleared(){
    this.isDeployement ="";
    // this.w700jobslist =[];
    this.searchText ="";
  }

  onKeyUpSearchJobslist(event: any) {

    var val = event;
    this.searchtext = val;
    if (Number(val.length) + Number(1) > 2 || val ==='') {
      this.ngxUiLoaderService.start()
      this.w700jobslist=[]
      let deployement =  typeof(this.isDeployement)=="string"||typeof(this.isDeployement)==undefined? this.isDeployement:this.isDeployement['name'];
      // this.w700service.getapiurl("api/W700Jobs/GetW700ApplicationJobs?searchvalue=" + val, deployement).subscribe(response => {
      //   if (response['status'] && response['statusText']) {
      //   }
      //   else {
      //     this.ngxUiLoaderService.stop()
      //     this.w700jobslist = response as any[];
      //     if (this.w700jobslist.length > 0) {
      //       this.datashow = true;
      //     }
      //     else {
      //       this.datashow = false;
      //     }
      //   }
      // },error=>{
      //   this.ngxUiLoaderService.stop()
      // })
      var apiname = "api/VitalHubDXAPI/GetW700ApplicationJobs?searchvalue=" + val;
    
      this.w700service.getapi(apiname, deployement).subscribe({
        next: data => {
          this.w700jobslist = data as any[];
          this.jobNames = this.w700jobslist.map(job => job.JobName); 
          this.datashow = this.w700jobslist.length > 0;
          if(this.w700jobslist.length <= 0)
          {
            this.toastr.error( 'W700 Jobs Not Found ', "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }
          this.ngxUiLoaderService.stop();
        },
        error: error => {
          this.ngxUiLoaderService.stop();
        }
      });
    } else {
      this.w700jobslist = [];
      this.datashow = false;
    }
  }
  datashow: boolean = false;
  w700jobslist: any = [];

  // numbers = [];
  // noOfPages: number;
  // pageSize = 10;
  // currentPage = 0;
  // setPage(value) {
  //   this.currentPage = value;
  // }
  // setPagePrev() {
  //   if (this.currentPage != 0) {
  //     this.currentPage = this.currentPage - 1;
  //   }
  // }
  // setPageNext() {
  //   if (this.currentPage < this.noOfPages - 1) {
  //     this.currentPage = this.currentPage + 1;
  //   }
  // }

  public dataToModal: any;
  openCreateJobpopup(item) {
    // Create New passes an empty item; Edit passes a job object.
    // Block only Create New when Deployment is not selected (same rule as onSearchJobs).
    // Existing modal open / data flow below is unchanged when validation passes.
    if (!item && !this.isDeployement) {
      this.toastr.warning('Please select a Deployment before creating a job', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    this.dataToModal = {
      deploymentkey: typeof(this.isDeployement)=="string"||typeof(this.isDeployement)==undefined? this.isDeployement:this.isDeployement['name'],
      dataitem: {
        ...item,
        OperationValue: item.OperationValue === "" ? item.ClassName : item.OperationValue
      }
    }
    const createJobModalRef = this.modalService.open(CreatejobComponent,
      { windowClass: "myCustomModalClassjob", backdrop: 'static', keyboard: false, size: 'lg', });
    createJobModalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
    this.currentModalRefs.push(createJobModalRef);
    
    createJobModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== createJobModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== createJobModalRef);
      }
    );
    
    // modalRef.result.then(() => {
    //    this.onKeyUpSearchJobslist(this.searchtext);
    // });
    createJobModalRef.componentInstance.jobContent.subscribe((data: string) => {
    //  this.onKeyUpSearchJobslist(data);  
    this.activeModal.close(); 
  });
    
    this.modalTabVisibility.tagOwned('data-w700jobslist-modal', 'myCustomModalClassjob');
    this.modalWasOpen = true;
  }
  searchtext: string = '';

  openpropertiesJobpopup(item) {
    
    this.dataToModal = {
      deploymentkey: this.isDeployement,
      dataitem: item
    }
    const propertiesModalRef = this.modalService.open(JobpropertiesComponent,
      { windowClass: "myCustomModalClassjob", backdrop: 'static', keyboard: false });
    propertiesModalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
    this.currentModalRefs.push(propertiesModalRef);
    
    propertiesModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== propertiesModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== propertiesModalRef);
      }
    );
    
    propertiesModalRef.componentInstance.jobPropertiesContent.subscribe((data: string) => {
        this.onKeyUpSearchJobslist(data);    
    });
    
    this.modalTabVisibility.tagOwned('data-w700jobslist-modal', 'myCustomModalClassjob');
    this.modalWasOpen = true;
  }
  onSearchJobs()
  {
    if (!this.isDeployement) {     
      this.toastr.warning('Deployment is Mandatory', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
      return; 
    }
  
    this.onKeyUpSearchJobslist(this.searchtext || '');
  }
  getstatus(spKey: boolean): string {
    return spKey === true ? 'Active' : 'Inactive';
  }

  getFrequency(frequencyType: string): string {
    if (frequencyType in W700jobslistComponent.displayFrequency) {
      return W700jobslistComponent.displayFrequency[frequencyType];
    }
    return frequencyType; 
  }

  hideModals() {
    const result = this.modalTabVisibility.hideOwned('data-w700jobslist-modal', {
      hasOpenRefs: this.currentModalRefs?.length > 0,
      windowClasses: ['myCustomModalClassjob'],
      extraSelectors: ['#newPopupModal.custom-modal', '.custom-modal[data-w700jobslist-modal="true"]'],
    });
    this.modalWasOpen = result.modalWasOpen;
  }

  showModals() {
    this.modalTabVisibility.showOwned('data-w700jobslist-modal', {
      modalWasOpen: this.modalWasOpen,
      hasOpenRefs: this.currentModalRefs?.length > 0,
      windowClasses: ['myCustomModalClassjob'],
      extraSelectors: ['#newPopupModal.custom-modal[data-w700jobslist-modal="true"]', '.custom-modal[data-w700jobslist-modal="true"]'],
    });
  }

}
